import { getUriQueryParameter } from '@impuls-coach/util-get-uri-query-parameter';
import * as React from 'react';

import i18n from 'helper/i18n';
import noop from 'helper/noop';

import { routes } from 'defs';
import { EventImageCodes, EventLevels, EventTypes } from 'defs/events';

import Checkbox from 'components/atoms/Checkbox';
import Agreement from 'components/molecules/Agreement';
import ButtonBar from 'components/molecules/ButtonBar';
import ElementList from 'components/molecules/ElementList';
import { AnamnesisStepResolver } from 'components/organisms/Anamnesis';

export type DisclaimerProps = {
	buttons: Object[];
	doFinish: Function;
	isUpdatingAnamnesis: boolean;
	onStepCompleted: (resolver: AnamnesisStepResolver) => void;
	onNavigationClick: (targetUrl: { href: string }) => void;
	disclaimerAccepted?: boolean;
	hasNewsletterSubscription?: boolean;
	doAddEvents: Function;
	location?: {
		search?: string;
	};
	router: {
		push: Function;
	};
};

export type DisclaimerState = {
	acceptedCheckbox: boolean;
};

export default class Disclaimer extends React.Component<DisclaimerProps, DisclaimerState> {
	public static displayName = 'AnamnesisDisclaimer';
	public static defaultProps = {
		buttons: [],
		disclaimerAccepted: false,
		doFinish: noop,
		onNavigationClick: noop,
		onStepCompleted: noop,
		doAddEvents: noop,
		hasNewsletterSubscription: false,
	};

	constructor(props: DisclaimerProps) {
		super(props);

		this.state = {
			acceptedCheckbox: false,
		};
	}

	get urlStartProgram() {
		const location = this.props.location;

		if (!location || typeof location.search !== 'string') {
			return void 0;
		}

		return getUriQueryParameter('urlStartProgram', location.search);
	}

	public onChangeCheckbox = (state: boolean) => {
		this.setState({
			acceptedCheckbox: !!state,
		});
	};

	public onSubmitFinished = () => {
		const { disclaimerAccepted, doFinish, onStepCompleted, doAddEvents, hasNewsletterSubscription } = this.props;

		if (this.urlStartProgram) {
			onStepCompleted({
				waitFor: 'savedFinished',
				actionCreator: doFinish,
				nextRoute: routes.program.recommended,
				nextStepUrl: this.urlStartProgram,
			});

			return;
		}

		onStepCompleted({
			waitFor: 'savedFinished',
			actionCreator: doFinish,
			nextRoute: routes.program.recommended,
			search: '?anamnesisDone=true',
		});

		if (!disclaimerAccepted && !hasNewsletterSubscription) {
			doAddEvents([
				{
					eventLevel: EventLevels.NotAvailable,
					code: EventImageCodes.Newsletter,
					eventType: EventTypes.Image,
					coach: 'leo',
				},
			]);
		}
	};

	get shouldShowButtons(): boolean {
		return this.state && this.state.acceptedCheckbox;
	}

	public render() {
		const { buttons, isUpdatingAnamnesis } = this.props;

		return (
			<div>
				<Agreement text={i18n('react.impulsCoach.components.anamnesis.disclaimer.checkbox.text')}>
					<ElementList>
						<Checkbox
							tag="li"
							id="anamnesis-disclaimer-accept"
							name="anamnesis-disclaimer-accept"
							label={i18n('react.impulsCoach.components.anamnesis.disclaimer.checkbox.labelText')}
							onChange={this.onChangeCheckbox}
							modifier="white"
							disabled={isUpdatingAnamnesis}
						/>
					</ElementList>
				</Agreement>

				<div className="o-anamnesis__button-bar">
					{this.shouldShowButtons && (
						<ButtonBar
							buttons={buttons}
							loading={this.props.isUpdatingAnamnesis}
							handleButtonClicks={this.onSubmitFinished}
						/>
					)}
				</div>
			</div>
		);
	}
}
